export enum RouteNames {
  home = '/',
  novaCopia = '/nova-copia',
  novaPlantilla = '/nova-plantilla',
  llistatPlantilles = '/llistat-plantilles',
  editarPlantilla = '/editar-plantilla/:id',
  llistatOrgans = '/llistat-organs',
  sessioCopia = '/sessio-copia',
  copiaCallback = '/callback',
  errorPage = '/error'
}

export enum ExternalLinks {
  createCopiaHelp = 'https://suport-copia.aoc.cat/hc/ca/articles/4405306378269-Com-es-crea-una-c%25C3%25B2pia-aut%25C3%25A8ntica-a-C%25C3%2592PIA-',
  plantillesHelp = 'https://suport-copia.aoc.cat/hc/ca/articles/4405313100957-Per-qu%25C3%25A8-serveixen-les-plantilles-a-l-aplicaci%25C3%25B3-C%25C3%2592PIA-',
  copiaHelp = 'https://suport-copia.aoc.cat/hc/ca/articles/4405306384157-Com-puc-consultar-les-c%C3%B2pies-aut%C3%A8ntiques-que-he-generat-',
  firstStepsHelp = 'https://suport-copia.aoc.cat/hc/ca/articles/4405306365469-Primers-passos-per-utilitzar-l-aplicaci%C3%B3-C%C3%92PIA-dins-de-l-EACAT-'
}

export interface Scopes {
  routes: RouteNames[]
}
